import React from "react";

export default function StatTile({ label, value, sub, testid }) {
  return (
    <div
      className="rounded-xl border border-[#EAE6E1] bg-white p-4 transition-soft hover:border-[#547A8F]/40"
      data-testid={testid}
    >
      <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#6B7068] mb-1.5">
        {label}
      </div>
      <div className="font-mono-ticker text-xl text-[#2A2F2B]">{value}</div>
      {sub && <div className="text-xs text-[#6B7068] mt-0.5">{sub}</div>}
    </div>
  );
}
